// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/monitoring/v2/credential.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Credentials is the entity that represent credentials needed to get access to resources.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.Credentials
 */
export const Credentials = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.Credentials",
  () => [
    { no: 1, name: "aws", kind: "message", T: Credentials_AWSCredentials, oneof: "cred" },
    { no: 2, name: "azure", kind: "message", T: Credentials_AzureCredentials, oneof: "cred" },
  ],
);

/**
 * AWSCredentials is the entity which represent AWS Credentials.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.Credentials.AWSCredentials
 */
export const Credentials_AWSCredentials = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.Credentials.AWSCredentials",
  () => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "secret_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "role_arn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "role_external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "session_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credentials_AWSCredentials"},
);

/**
 * AzureCredentials is the entity which represent Azure Credentials.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.Credentials.AzureCredentials
 */
export const Credentials_AzureCredentials = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.Credentials.AzureCredentials",
  () => [
    { no: 1, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sas_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sas_container", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "storage_connection_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credentials_AzureCredentials"},
);

